class SliderCollectionList extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.swiper'); // container
    this.slider = this.querySelector('.swiper-wrapper');
    this.nextButton = this.querySelector('.slider-button--next');
    this.prevButton = this.querySelector('.slider-button--prev');
    this.counterCurrent = this.querySelector('.slider-counter--current');
    this.counterTotal = this.querySelector('.slider-counter--total');

    this.desktopEnabled = this.dataset.desktopSlider === 'true';
    this.mobileEnabled = this.dataset.mobileSlider === 'true';
    this.columnsDesktop = parseInt(this.dataset.columnsDesktop || 4);
    this.columnsMobile = parseInt(this.dataset.columnsMobile || 2);

    this.swiper = null;
    this.mql = window.matchMedia('(min-width: 750px)');
  }

  connectedCallback() {
    this.initSlider();
    this.mql.addEventListener('change', () => this.initSlider());
  }

  initSlider() {
    const isDesktop = this.mql.matches;

    const styles = getComputedStyle(this);
    const desktopGap = parseInt(styles.getPropertyValue('--grid-desktop-horizontal-spacing')) || 10;
    const mobileGap = parseInt(styles.getPropertyValue('--grid-mobile-horizontal-spacing')) || 8;

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
      this.container.classList.remove('is-swiper-enabled');
    }

    if ((isDesktop && !this.desktopEnabled) || (!isDesktop && !this.mobileEnabled)) {
      console.log('Grid mode active (no swiper)');
      return;
    }

    this.container.classList.add('is-swiper-enabled');
    this.swiper = new Swiper(this.container, {
      slidesPerView: isDesktop ? this.columnsDesktop : this.columnsMobile,
      spaceBetween: isDesktop ? desktopGap : mobileGap,
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      on: {
        init: () => this.updateCounter(),
        slideChange: () => this.updateCounter(),
      },
    });

    console.log('Swiper initialized:', this.swiper);
  }

  updateCounter() {
    if (!this.counterCurrent || !this.counterTotal || !this.swiper) return;
    this.counterCurrent.textContent = this.swiper.realIndex + 1;
    this.counterTotal.textContent = this.swiper.slides.length;
  }
}

customElements.define('slider-collection-list', SliderCollectionList);